import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { useTheme } from "@mui/material/styles";
import { Rating } from "@mui/material";
import {
  MyTextArea,
  MyTextInput,
} from "../services/authentication/inputServices";
import { Store } from "react-notifications-component";
import {
  getAllRatingAndReview,
  deleteRatingAndReview,
} from "../services/web/webServices";
import Loader from "../components/Helpper/Loader";

function RatingAndRiview() {
  const theme = useTheme();
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const [getButton, setButton] = useState(true);
  const [getLoader, setLoader] = useState(true);
  const [select, setSelection] = useState([]);
  const [ContentRowData, setContentRowData] = useState([]);
  const [ContentSelectedId, setContentSelectedId] = useState(null);
  const [contentDetail, setContentDetail] = useState([]);
  const [showEye, setShowEye] = useState(false);
  const pageName = "Rating and Review Management";

  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const handleClose1 = () => setShowEye(false);
  const handleShow1 = (params) => {
    setContentRowData(params);
    setContentSelectedId(params.row.id);
    setShowEye(true);
  };

  const onDelete = (params) => () => {
    if (window.confirm("Are you sure you want to delete?")) {
      deleteRatingAndReview(params.row.id)
        .then((res) => {
          Store.addNotification({
            title: "Success",
            message: res?.data?.message,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 3000,
              onScreen: true,
            },
          });

          setLoader(true);
          getAllRatingAndReview()
            .then((res) => {
              const data = Array.isArray(res?.data?.data) ? res.data.data : [];
              setContentDetail(
                data.map((el, index) => ({
                  ...el,
                  id: el.id,
                  i: index,
                }))
              );
              setLoader(false);
            })

            .catch((err) => {
              setLoader(false);
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const columns = [
    {
      field: "sno",
      headerName: "S.NO.",
      filterable: false,
      renderCell: (index) => `${index.row.i + 1}`,
      width: 80,
    },

    {
      field: "firstName",
      headerName: "Name",
      width: 180,
      renderCell: (params) =>
        `${params.row.userId.firstName} ${params.row.userId.lastName}`,
    },

    {
      field: "email",
      headerName: "Email",
      width: 180,
      renderCell: (params) => `${params.row.userId.email}`,
    },
    {
      field: "rating",
      headerName: "Rating",
      width: 180,
      renderCell: (params) => {
        return (
          <Rating
            value={params?.row?.rating} // Pass the rating value here
            readOnly // Make it read-only if you don't want users to change it
            precision={0.5} // You can set precision for half-star ratings
          />
        );
      },
    },
    {
      field: "review",
      headerName: "Review",
      width: 180,
    },
    {
      field: "title",
      headerName: "Place",
      width: 180,
      renderCell: (params) => params?.row?.placeId?.title ?? "N/A",
    },
    {
      field: "action",
      headerName: "Action",
      width: 310,

      renderCell: (params) => {
        return (
          <>
            <Button
              style={{
                backgroundColor: "#64A433",
                border: "none",
                marginRight: "5px",
              }}
              onClick={() => handleShow1(params)}
            >
              <i className="fas fa-eye"></i>
            </Button>
            <Button
              color="error"
              onClick={onDelete(params)}
              style={{ backgroundColor: "#64A433", border: "none" }}
            >
              <i className="fa fa-trash" aria-hidden="true"></i>
            </Button>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    setLoader(true);
    getAllRatingAndReview()
      .then((res) => {
        const data = Array.isArray(res?.data?.data) ? res.data.data : [];
        setContentDetail(
          data.map((el, index) => ({
            ...el,
            id: el.id,
            i: index,
          }))
        );

        setLoader(false);
      })

      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  }, []);

  const css = `
    
.form-group {
  margin-bottom: 20px;
}

.form-control {
  width: 100%;
  padding: 8px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  
}
  .form-control-edit {
  width: 100%;
  padding: 8px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  height:110px
}


  .form-submit{
    padding: 10px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  cursor: pointer;  
  border-radius: 5px;
  }
.form-submit:hover {
  background-color: #4CAF50; /* Darker green on hover */
  transform: scale(1.05); /* Slightly enlarge the button */
}

.form-submit:disabled {
  background-color: #9e9e9e; /* Grey color when disabled */
  cursor: not-allowed; /* Change cursor to not-allowed when disabled */
}
  .form-label {
  margin-bottom: 5px;
  display: block;
  font-weight: bold;
}
      .form-label {
  margin-bottom: 5px;
  display: block;
  font-weight: bold;
  color: #555659; 
}
  `;

  return (
    <>
      <style>{css}</style>
      <div className="grid-container">
        <Sidebar
          openSidebarToggle={openSidebarToggle}
          OpenSidebar={OpenSidebar}
        />
        <Header OpenSidebar={OpenSidebar} pageName={pageName} />
        <div
          style={{
            gridArea: "main",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            // margin: "0 150px 150px",
            margin: "0 90px 150px",
          }}
        >
          <Box
            sx={{ height: 500, width: "100%", boxShadow: 7, marginTop: "85px" }}
          >
            {getLoader ? (
              <Loader />
            ) : contentDetail.length > 0 ? (
              <>
                <DataGrid
                  rows={contentDetail}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: { page: 0, pageSize: 10 },
                    },
                  }}
                  pageSizeOptions={[5, 10, 25]}
                  disableRowSelectionOnClick
                  onSelectionChange={(newSelection) => {
                    setSelection(newSelection.rows);
                  }}
                  sx={{
                    "& .MuiDataGrid-row:nth-of-type(odd)": {
                      backgroundColor: theme.palette.action.hover, // Light grey background
                    },
                    "& .MuiDataGrid-cell:last-child": {
                      border: 0, // Hide the last cell border
                    },
                  }}
                />
              </>
            ) : (
              <p style={{ fontSize: "30px", padding: "30px" }}>
                No data found.
              </p>
            )}
          </Box>
          {/* modal for view content management------------------------- */}

          <Modal show={showEye} onHide={handleClose1} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>Rating and Review Management</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Formik
                initialValues={{
                  name: ContentRowData?.row?.userId?.firstName
                    ? `${ContentRowData?.row?.userId?.firstName} ${
                        ContentRowData?.row?.userId?.lastName || ""
                      }`
                    : ContentRowData?.row?.userId?.lastName || "N/A",

                  email: ContentRowData?.row?.userId?.email
                    ? ContentRowData?.row?.userId?.email
                    : "N/A",

                  review: ContentRowData?.row?.review
                    ? ContentRowData?.row?.review
                    : "N/A",

                  place: ContentRowData?.row?.placeId?.title
                    ? ContentRowData?.row?.placeId?.title
                    : "N/A",
                 
                }}
              >
                {(props) => (
                  <Form>
                    <div className="form-group">
                      <label className="form-label">Name:</label>
                      <MyTextInput
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        readOnly
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Email:</label>
                      <MyTextInput
                        type="text"
                        id="email"
                        name="email"
                        className="form-control"
                        readOnly
                      />
                    </div>
                    {/* <div className="form-group">
                      <label className="form-label">Email:</label>
                      <MyTextArea
                        type="text"
                        id="email"
                        name="email"
                        className="form-control"
                        readOnly
                      />
                    </div> */}
                    <div className="form-group">
                      <label className="form-label">Review:</label>
                      <MyTextArea
                        type="text"
                        id="review"
                        name="review"
                        className="form-control-edit"
                        readOnly
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Place:</label>
                      <MyTextInput
                        type="text"
                        id="place"
                        name="place"
                        className="form-control"
                        readOnly
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose1}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default RatingAndRiview;
